import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import TicketChat from './ticketChat/ticketChat'
import TicketDetails from './ticketDetails'
import { request } from '../../../../Redux/Sagas/requests/api'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { primary_color } from '../../../../Helper/uiHelper'
import { isSuccessResponse } from '../../../../helper'
import { ConvertToFAQ } from './ticketChat/convertToFAQ'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../../Redux/Reducers/CMS'

const EditTicket = ({ setAddGridDataDetail, form, addDataDetail}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const currentRow = useSelector((state) => state.CMS.currentRow)

  const [ticketDetails, setTicketDetails] = useState({})
  const [showCloseModal, setShowCloseModal] = useState(false)
  const [faqDetails, setFAQdetails] = useState({})
  const [showFAQform, setShowFAQform] = useState(false)

  const PERMISSIONS = addDataDetail?.currentTabData?.permission

  console.log('add data detail::::', addDataDetail)

  useEffect(() => {
    getTicketDetails()
  }, [])

  const getTicketDetails = () => {
    request('raise-ticket/get/ticket-details', 'POST', { ticket_id: currentRow?.[0]?.id }).then((res) => {
      setTicketDetails(res?.data?.data)
      const ticketDetails = res?.data?.data?.ticket
      let obj = {}
      obj['query_id'] = ticketDetails?.query_id
      obj['query_id_label'] = ticketDetails?.query_id_label
      obj['query_type_id'] = ticketDetails?.query_type?.id
      obj['query_type_id_label'] = ticketDetails?.query_type?.name
      obj['question'] = ticketDetails?.subject
      obj['display'] = true
      setFAQdetails(obj)
    })
  }

  const onGoBack = () => {
    dispatch(fetchUpdateApiData())
    dispatch(clearCurrentRowData())
    dispatch(clearParentTableData())

    setAddGridDataDetail({ open: false })
  }

  const onCloseTicket = (redirectToFAQ) => {
    request('raise-ticket/close-ticket', 'POST', { ticket_id: currentRow?.[0]?.id }).then((res) => {
      if (isSuccessResponse(res, 'Ticket closed successfully!')) {
        if (redirectToFAQ) {
          onGoBack()
          history.push("/faq's-list")
        } else {
          getTicketDetails()
        }
      }
    })
  }
  if (showFAQform)
    return (
      <ConvertToFAQ
        defaultValue={faqDetails}
        onCloseForm={() => {
          setShowCloseModal(false)
          setShowFAQform(false)
        }}
        onCloseTicket={onCloseTicket}
      />
    )
  return (
    <>
      {' '}
      <Button
        color='dark'
        className='mb-4 subtitle1'
        onClick={() => {
          onGoBack()
        }}>
        <i class='fa-solid fa-arrow-left mr-2'></i> Back
      </Button>
      <div className='d-flex'>
        <div style={{ flex: 1 }}>
          <TicketDetails data={ticketDetails} form={form} getTicketDetails={getTicketDetails} PERMISSIONS={PERMISSIONS} />
        </div>
        <div style={{ flex: 3 }}>
          <TicketChat
            id={currentRow?.[0]?.id}
            ticketDetails={ticketDetails}
            setShowCloseModal={setShowCloseModal}
            setFAQdetails={setFAQdetails}
            getTicketDetails={getTicketDetails}
            PERMISSIONS={PERMISSIONS}
            setTicketDetails={setTicketDetails}
          />
        </div>
        <Modal
          isOpen={showCloseModal}
          centered={true}
          toggle={() => {
            setShowCloseModal(false)
          }}
          style={{ width: '30rem', boxShadow: 'none', maxWidth: '50rem' }}>
          <ModalBody>
            <div
              style={{ backgroundColor: '#FFF', border: 'none', padding: '2rem', color: primary_color }}
              className='font-weight-bold body1 text-center'>
              Do you want to convert this Query Ticket into a FAQ?
            </div>
            <div className='d-flex justify-content-between'>
              <button
                className='btn rounded-pill mt-2 text-danger border-danger'
                type='button'
                onClick={() => {
                  onCloseTicket()
                  setShowCloseModal(false)
                }}
                style={{ fontWeight: 700, width: '48%' }}>
                No
              </button>
              <button
                className='btn text-white rounded-pill mt-2'
                type='button'
                onClick={() => {
                  setShowFAQform(true)
                  setShowCloseModal(false)
                }}
                style={{ background: primary_color, fontWeight: 700, width: '48%' }}>
                Yes
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  )
}

export default EditTicket
